import { EditAltIcon } from 'cokitchen-icons';
import { AddStoreType } from 'models/store.model';
import React, { useState } from 'react';

const AddStoreDetailsPreview = ({
  form,
  setStep
}: {
  form: AddStoreType;
  setStep: (item: number) => void;
}) => {
  const [showDetails, setShowDetails] = useState({ basicDetails: true, parameterDetails: false });
  return (
    <div>
      <div className='mb-8'>
        <p className='font-semibold text-xl'>Review store creation</p>
        <p className='text-gray-9 text-sm'>
          Kindly select which parameters to display on the side menu
        </p>
      </div>
      <div>
        <div className='flex justify-between w-full items-center bg-[#F8F8F8] py-4 border border-[#F2F2F3] rounded-lg  px-3'>
          <p>Store details</p>
          <div className='flex gap-1 items-center '>
            <EditAltIcon className='cursor-pointer' onClick={() => setStep(1)} />
            <div className='rounded-full pl-[6px] '>
              <button
                onClick={() =>
                  setShowDetails({ ...showDetails, basicDetails: !showDetails.basicDetails })
                }
                className='text-sm font-medium bg-white text-gray-12 rounded-full px-4 py-[6px] border border-[#EAEBEB]'>
                {showDetails.basicDetails ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>
        </div>

        {showDetails.basicDetails && (
          <>
            <div className='flex justify-between border-b border-b-gray-13 py-5'>
              <p className='text-gray-9 capitalize'> Name</p>
              <p className='text-gray-10 font-medium text-sm'> {form?.name}</p>
            </div>
            <div className='flex justify-between border-b border-b-gray-13 py-5'>
              <p className='text-gray-9 capitalize'> Type</p>
              <p className='text-gray-10 font-medium text-sm'> {form?.type}</p>
            </div>

            <div className='flex justify-between border-b border-b-gray-13 py-5'>
              <p className='text-gray-9 capitalize'> Location</p>
              <p className='text-gray-10 font-medium text-sm'> {form?.location}</p>
            </div>

            <div className='flex justify-between items-center border-b border-b-gray-13 py-5'>
              <p className='text-gray-9 capitalize'> Logo</p>
              {!form?.logo ? (
                <p className='font-medium'>No logo</p>
              ) : (
                <img className='w-12 h-12 rounded-lg' src={form.logo} />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AddStoreDetailsPreview;
